import React from 'react';
import { Award, Download } from 'lucide-react';

function Profile({ xp, user, darkMode, setDarkMode, achievements = [], streak, gems, perfectLessonCount = 0, nightOwlCount = 0, earlyBirdCount = 0, totalTime = 0, flashcardsCount = 0, certificates = [], onDownloadCertificate }) {
  
  const achievementConfig = [
    {
      id: 'first_win',
      name: 'Erster Schritt',
      icon: '🥇',
      levels: [{ target: 1, desc: 'Schließe eine Lektion ab' }],
      progress: (achievements.includes('first_win') || xp > 0) ? 1 : 0
    },
    {
      id: 'streak',
      name: 'Feuer und Flamme',
      icon: '🔥',
      levels: [
        { target: 3, desc: 'Erreiche einen 3-Tage Streak' },
        { target: 7, desc: 'Erreiche einen 7-Tage Streak' },
        { target: 14, desc: 'Erreiche einen 14-Tage Streak' },
        { target: 30, desc: 'Erreiche einen 30-Tage Streak' },
        { target: 60, desc: 'Erreiche einen 60-Tage Streak' },
        { target: 100, desc: 'Erreiche einen 100-Tage Streak' },
        { target: 180, desc: 'Erreiche einen 180-Tage Streak' },
        { target: 365, desc: 'Erreiche einen 365-Tage Streak' }
      ],
      progress: streak
    },
    {
      id: 'perfect',
      name: 'Scharfschütze',
      icon: '🎯',
      levels: [
        { target: 1, desc: '1 Lektion ohne Fehler' },
        { target: 5, desc: '5 Lektionen ohne Fehler' },
        { target: 10, desc: '10 Lektionen ohne Fehler' },
        { target: 25, desc: '25 Lektionen ohne Fehler' },
        { target: 50, desc: '50 Lektionen ohne Fehler' },
        { target: 100, desc: '100 Lektionen ohne Fehler' },
        { target: 250, desc: '250 Lektionen ohne Fehler' },
        { target: 500, desc: '500 Lektionen ohne Fehler' }
      ],
      progress: perfectLessonCount
    },
    {
      id: 'xp',
      name: 'Wissensdurst',
      icon: '⚡',
      levels: [
        { target: 1000, desc: 'Sammle 1.000 XP' },
        { target: 5000, desc: 'Sammle 5.000 XP' },
        { target: 10000, desc: 'Sammle 10.000 XP' },
        { target: 25000, desc: 'Sammle 25.000 XP' },
        { target: 50000, desc: 'Sammle 50.000 XP' },
        { target: 75000, desc: 'Sammle 75.000 XP' },
        { target: 100000, desc: 'Sammle 100.000 XP' },
        { target: 250000, desc: 'Sammle 250.000 XP' }
      ],
      progress: xp
    },
    {
      id: 'night_owl',
      name: 'Nachteule',
      icon: '🦉',
      levels: [
        { target: 3, desc: '3 Lektionen nach 22 Uhr' },
        { target: 10, desc: '10 Lektionen nach 22 Uhr' },
        { target: 25, desc: '25 Lektionen nach 22 Uhr' },
        { target: 50, desc: '50 Lektionen nach 22 Uhr' },
        { target: 100, desc: '100 Lektionen nach 22 Uhr' }
      ],
      progress: nightOwlCount
    },
    {
      id: 'early_bird',
      name: 'Früher Vogel',
      icon: '🌅',
      levels: [
        { target: 3, desc: '3 Lektionen vor 8 Uhr' },
        { target: 10, desc: '10 Lektionen vor 8 Uhr' },
        { target: 25, desc: '25 Lektionen vor 8 Uhr' },
        { target: 50, desc: '50 Lektionen vor 8 Uhr' },
        { target: 100, desc: '100 Lektionen vor 8 Uhr' }
      ],
      progress: earlyBirdCount
    },
    {
      id: 'marathon',
      name: 'Marathon',
      icon: '⏱️',
      levels: [
        { target: 3600, desc: '1 Stunde gelernt' },
        { target: 18000, desc: '5 Stunden gelernt' },
        { target: 36000, desc: '10 Stunden gelernt' },
        { target: 86400, desc: '24 Stunden gelernt' },
        { target: 180000, desc: '50 Stunden gelernt' },
        { target: 360000, desc: '100 Stunden gelernt' },
        { target: 900000, desc: '250 Stunden gelernt' },
        { target: 1800000, desc: '500 Stunden gelernt' }
      ],
      progress: totalTime
    },
    {
      id: 'memory_pro',
      name: 'Gedächtnis-Profi',
      icon: '🧠',
      levels: [
        { target: 10, desc: '10 Karteikarten wiederholt' },
        { target: 50, desc: '50 Karteikarten wiederholt' },
        { target: 100, desc: '100 Karteikarten wiederholt' },
        { target: 250, desc: '250 Karteikarten wiederholt' },
        { target: 500, desc: '500 Karteikarten wiederholt' },
        { target: 1000, desc: '1000 Karteikarten wiederholt' },
        { target: 2500, desc: '2500 Karteikarten wiederholt' },
        { target: 5000, desc: '5000 Karteikarten wiederholt' }
      ],
      progress: flashcardsCount
    },
    {
      id: 'weekend_warrior',
      name: 'Wochenend-Krieger',
      icon: '📅',
      levels: [{ target: 1, desc: 'Lerne am Samstag und Sonntag' }],
      progress: achievements.includes('weekend_warrior') ? 1 : 0
    },
    {
      id: 'graduate',
      name: 'Absolvent',
      icon: '🎓',
      levels: [{ target: 1, desc: 'Schließe einen kompletten Abschnitt ab' }],
      progress: achievements.includes('graduate') ? 1 : 0
    },
    {
      id: 'survivor',
      name: 'Überlebenskünstler',
      icon: '🚑',
      levels: [{ target: 1, desc: 'Lektion mit 1 Herz beendet' }],
      progress: achievements.includes('survivor') ? 1 : 0
    },
    {
      id: 'speed_coder',
      name: 'Speed Coder',
      icon: '🏎️',
      levels: [{ target: 1, desc: 'Lektion unter 90s beendet' }],
      progress: achievements.includes('speed_coder') ? 1 : 0
    }
  ];

  const availableCertificates = [
    { name: 'HTML', icon: "https://raw.githubusercontent.com/devicons/devicon/master/icons/html5/html5-original.svg" },
    { name: 'Python', icon: "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg" },
    { name: 'JavaScript', icon: "https://raw.githubusercontent.com/devicons/devicon/master/icons/javascript/javascript-original.svg" },
    { name: 'Kotlin', icon: "https://raw.githubusercontent.com/devicons/devicon/master/icons/kotlin/kotlin-original.svg" }
  ];

  const joinDate = user && user.metadata && user.metadata.creationTime 
    ? new Date(user.metadata.creationTime).toLocaleDateString('de-DE', { month: 'long', year: 'numeric' }) 
    : 'März 2021';

  return (
    <main className="main-content" style={{ height: '100vh', overflowY: 'auto', paddingBottom: '40px', position: 'relative' }}>
      <style>{`
        @keyframes pop-up {
          0% { transform: scale(0.95); opacity: 0; }
          100% { transform: scale(1); opacity: 1; }
        }
      `}</style>
      <div className="main-content-header" style={{ position: 'sticky', top: '20px', zIndex: 10, backgroundColor: '#1cb0f6', borderBottom: '4px solid #148ac2', borderRadius: '16px', color: 'white', marginBottom: '20px', marginTop: '20px' }}>
        <h2>Profil</h2>
        <span>Dein Fortschritt</span>
      </div>
      
      <div style={{ width: '100%', maxWidth: '600px', margin: '0 auto', padding: '0 20px', boxSizing: 'border-box' }}>
        
        {/* Profile Header Card */}
        <div style={{
            backgroundColor: darkMode ? 'rgba(43, 43, 43, 0.05)' : 'rgba(255, 255, 255, 0.03)',
            backdropFilter: 'blur(5px)',
            WebkitBackdropFilter: 'blur(5px)',
            border: darkMode ? '2px solid #444' : '2px solid #e5e5e5',
            borderRadius: '24px',
            padding: '20px',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: '20px',
            marginBottom: '30px',
            boxShadow: '0 4px 0 rgba(0,0,0,0.05)',
            animation: 'pop-up 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275) 0s both'
        }}>
            <div style={{ 
                width: '80px', 
                height: '80px', 
                borderRadius: '50%', 
                overflow: 'hidden', 
                backgroundColor: '#f0f0f0',
                flexShrink: 0
            }}>
                 {user && user.photoURL ? (
                  <img src={user.photoURL} alt="Profil" style={{ width: '100%', height: '100%', objectFit: 'cover' }} referrerPolicy="no-referrer" />
                ) : (
                  <div style={{ width: '100%', height: '100%', backgroundColor: '#1cb0f6', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '35px' }}>👤</div>
                )}
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
                <h1 style={{ fontSize: '1.3rem', margin: '0', color: darkMode ? '#fff' : '#3c3c3c', fontWeight: '800', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{user ? user.displayName : 'Coding Schüler'}</h1>
                <div style={{ color: darkMode ? '#888' : '#afafaf', fontSize: '0.9rem', fontWeight: '600', marginBottom: '3px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{user ? user.email : 'Gast'}</div>
                <div style={{ color: darkMode ? '#666' : '#ccc', fontSize: '0.8rem', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '1px' }}>Dabei seit {joinDate}</div>
            </div>
        </div>

        <div style={{ height: '2px', backgroundColor: darkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)', margin: '30px 0' }}></div>

        <h3 style={{ fontSize: '1.2rem', marginBottom: '20px', color: darkMode ? '#fff' : '#3c3c3c', fontWeight: '800' }}>Statistik</h3>

        {/* Stats Row */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(130px, 1fr))', gap: '15px', marginBottom: '40px' }}>
            <div style={{ 
                backgroundColor: darkMode ? 'rgba(43, 43, 43, 0.05)' : 'rgba(255, 255, 255, 0.03)',
                backdropFilter: 'blur(5px)',
                WebkitBackdropFilter: 'blur(5px)',
                border: darkMode ? '2px solid #444' : '2px solid #e5e5e5',
                borderRadius: '20px', 
                padding: '15px', 
                display: 'flex', 
                flexDirection: 'row', 
                alignItems: 'center', 
                justifyContent: 'center',
                gap: '15px',
                boxShadow: '0 4px 0 rgba(0,0,0,0.05)',
                animation: 'pop-up 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275) 0.1s both'
            }}>
                <span style={{ fontSize: '24px' }}>🔥</span>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', minWidth: 0 }}>
                    <div style={{ fontSize: '1rem', fontWeight: '800', color: darkMode ? '#fff' : '#3c3c3c', lineHeight: 1 }}>{streak || 0}</div>
                    <div style={{ fontSize: '0.7rem', color: darkMode ? '#888' : '#afafaf', fontWeight: '700', textTransform: 'uppercase' }}>Streak</div>
                </div>
            </div>
            <div style={{ 
                backgroundColor: darkMode ? 'rgba(43, 43, 43, 0.05)' : 'rgba(255, 255, 255, 0.03)',
                backdropFilter: 'blur(5px)',
                WebkitBackdropFilter: 'blur(5px)',
                border: darkMode ? '2px solid #444' : '2px solid #e5e5e5',
                borderRadius: '20px', 
                padding: '15px', 
                display: 'flex', 
                flexDirection: 'row', 
                alignItems: 'center', 
                justifyContent: 'center',
                gap: '15px',
                boxShadow: '0 4px 0 rgba(0,0,0,0.05)',
                animation: 'pop-up 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275) 0.2s both'
            }}>
                <span style={{ fontSize: '24px' }}>⚡</span>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', minWidth: 0 }}>
                    <div style={{ fontSize: '1rem', fontWeight: '800', color: darkMode ? '#fff' : '#3c3c3c', lineHeight: 1 }}>{xp}</div>
                    <div style={{ fontSize: '0.7rem', color: darkMode ? '#888' : '#afafaf', fontWeight: '700', textTransform: 'uppercase' }}>Gesamt XP</div>
                </div>
            </div>
             <div style={{ 
                backgroundColor: darkMode ? 'rgba(43, 43, 43, 0.05)' : 'rgba(255, 255, 255, 0.03)',
                backdropFilter: 'blur(5px)',
                WebkitBackdropFilter: 'blur(5px)',
                border: darkMode ? '2px solid #444' : '2px solid #e5e5e5',
                borderRadius: '20px', 
                padding: '15px', 
                display: 'flex', 
                flexDirection: 'row', 
                alignItems: 'center', 
                justifyContent: 'center',
                gap: '15px',
                boxShadow: '0 4px 0 rgba(0,0,0,0.05)',
                animation: 'pop-up 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275) 0.3s both'
            }}>
                <span style={{ fontSize: '24px' }}>💎</span>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', minWidth: 0 }}>
                    <div style={{ fontSize: '1rem', fontWeight: '800', color: darkMode ? '#fff' : '#3c3c3c', lineHeight: 1 }}>{gems || 0}</div>
                    <div style={{ fontSize: '0.7rem', color: darkMode ? '#888' : '#afafaf', fontWeight: '700', textTransform: 'uppercase' }}>Edelsteine</div>
                </div>
            </div>
        </div>
        
        <div style={{ height: '2px', backgroundColor: darkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)', margin: '30px 0' }}></div>

        {/* Certificates Section */}
        <h3 style={{ fontSize: '1.2rem', marginBottom: '20px', color: darkMode ? '#fff' : '#3c3c3c', fontWeight: '800' }}>Zertifikate</h3>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', gap: '15px', marginBottom: '40px' }}>
            {availableCertificates.map((cert, index) => {
                const unlocked = certificates.includes(cert.name);
                return (
                <div key={cert.name} style={{
                    backgroundColor: darkMode ? 'rgba(43, 43, 43, 0.05)' : 'rgba(255, 255, 255, 0.03)',
                    backdropFilter: 'blur(5px)',
                    WebkitBackdropFilter: 'blur(5px)',
                    border: unlocked ? '2px solid #ffc800' : (darkMode ? '2px solid #444' : '2px solid #e5e5e5'),
                    borderRadius: '20px',
                    padding: '20px 15px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '10px',
                    boxShadow: '0 4px 0 rgba(0,0,0,0.05)',
                    animation: `pop-up 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275) ${index * 0.1}s both`,
                    opacity: unlocked ? 1 : 0.5,
                    height: '100%',
                    minHeight: '180px'
                }}>
                    <div style={{ width: '50px', height: '50px', marginBottom: '5px', filter: unlocked ? 'none' : 'grayscale(100%) opacity(0.7)' }}>
                        <img src={cert.icon} alt={cert.name} style={{ width: '100%', height: '100%' }} />
                    </div>
                    <div style={{ textAlign: 'center' }}>
                        <h4 style={{ margin: '0 0 5px 0', fontSize: '0.9rem', color: darkMode ? '#fff' : '#3c3c3c', fontWeight: '800' }}>
                          {cert.name}<br/>Zertifikat
                        </h4>
                        {unlocked && <p style={{ margin: 0, fontSize: '0.75rem', color: darkMode ? '#888' : '#afafaf', lineHeight: '1.3' }}>
                            Abgeschlossen
                        </p>}
                    </div>
                    <button 
                        onClick={() => unlocked && onDownloadCertificate(cert.name)} 
                        disabled={!unlocked}
                        style={{ background: 'none', border: 'none', color: unlocked ? '#1cb0f6' : (darkMode ? '#777' : '#ccc'), fontWeight: 'bold', cursor: unlocked ? 'pointer' : 'default', display: 'flex', alignItems: 'center', gap: '5px', fontSize: '0.75rem', marginTop: '5px' }}
                    >
                        <Download size={14} /> PDF
                    </button>
                </div>
                );
            })}
        </div>

        <div style={{ height: '2px', backgroundColor: darkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)', margin: '30px 0' }}></div>

        {/* Achievements Section */}
        <h3 style={{ fontSize: '1.2rem', marginBottom: '20px', color: darkMode ? '#fff' : '#3c3c3c', fontWeight: '800' }}>Errungenschaften</h3>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', gap: '15px' }}>
          {achievementConfig.map((ach, index) => {
            // Level Berechnung
            let currentLevel = 0;
            for (let i = 0; i < ach.levels.length; i++) {
              if (ach.progress >= ach.levels[i].target) {
                currentLevel = i + 1;
              } else {
                break;
              }
            }
            
            // Nächstes Ziel oder Max
            const displayLevelIndex = Math.min(currentLevel, ach.levels.length - 1);
            const displayData = ach.levels[displayLevelIndex];
            const unlocked = currentLevel > 0;
            const isMaxed = currentLevel === ach.levels.length;
            const showLevelBadge = ach.levels.length > 1;

            return (
              <div key={ach.id} style={{ 
                  border: darkMode ? '2px solid #444' : '2px solid #e5e5e5', 
                  borderRadius: '20px', 
                  padding: '20px 15px', 
                  display: 'flex', 
                  flexDirection: 'column',
                  alignItems: 'center', 
                  justifyContent: 'center',
                  gap: '10px',
                  backgroundColor: darkMode ? 'rgba(43, 43, 43, 0.05)' : 'rgba(255, 255, 255, 0.03)',
                  backdropFilter: 'blur(5px)',
                  WebkitBackdropFilter: 'blur(5px)',
                  opacity: unlocked ? 1 : 0.5,
                  textAlign: 'center',
                  boxShadow: '0 4px 0 rgba(0,0,0,0.05)',
                  position: 'relative',
                  animation: `pop-up 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275) ${0.4 + index * 0.1}s both`,
                  height: '100%',
                  minHeight: '180px'
              }}>
                {showLevelBadge && (
                  <div style={{
                    position: 'absolute',
                    top: '10px',
                    right: '10px',
                    backgroundColor: darkMode ? '#555' : '#e0e0e0',
                    color: darkMode ? '#fff' : '#555',
                    fontSize: '0.65rem',
                    fontWeight: '800',
                    padding: '2px 6px',
                    borderRadius: '6px'
                  }}>
                    {currentLevel} / {ach.levels.length}
                  </div>
                )}
                <div style={{ 
                    fontSize: '40px',
                    filter: unlocked ? 'none' : 'grayscale(100%) opacity(0.5)',
                    marginBottom: '5px'
                }}>
                    {ach.icon}
                </div>
                <div>
                  <h4 style={{ margin: '0 0 5px 0', fontSize: '0.9rem', color: darkMode ? '#fff' : '#3c3c3c', fontWeight: '800' }}>{ach.name}</h4>
                  <p style={{ margin: 0, fontSize: '0.75rem', color: darkMode ? '#888' : '#afafaf', lineHeight: '1.3' }}>
                    {unlocked && !isMaxed ? ach.levels[currentLevel].desc : displayData.desc}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </main>
  );
}

export default Profile;